// Utility helpers related to household structure

/**
 * Safely read a household value by key, supporting both id and label matches.
 * Handles known label variants and returns a fallback if not found or invalid input.
 *
 * @param {Array<{id?: string, label?: string, value: number}>} household
 * @param {('adults'|'childrenUnder16'|'children16to18'|'numberOfVehicles'|string)} key
 * @param {number} [fallback=0]
 * @returns {number}
 */
export function getHouseholdValue(household, key, fallback = 0) {
  if (!Array.isArray(household)) return fallback;

  // Map keys to possible label variants that may appear in data/tests
  const labelMap = {
    adults: ['Adults'],
    childrenUnder16: ['Children under 16'],
    children16to18: ['Children 16-18', 'Children 16 - 18'], // support both hyphen spacings
    numberOfVehicles: ['Vehicles'],
  };

  const possibleLabels = labelMap[key] || [key];

  const item = household.find(h => {
    if (!h) return false;
    if (h.id === key) return true;
    const label = h.label;
    return typeof label === 'string' && possibleLabels.includes(label);
  });

  return item?.value ?? fallback;
}
